import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  accessToken: null,
  userData: {
    userNo: 0,
    name: '',
    joinType: 'GENERAL',
    status: 'ACTIVE',
    phone: '',
    isAuthPhone: false,
    isSeller: false,
    file: {}
  },
  deviceInfo: {
    userNo: null,
    deviceNo: null,
    deviceType: '',
    deviceId: '',
    pushToken: '',
    appVersion: '',
    os: ''
  },
  updateInfo: {
    versionNo: '',
    deviceType: '',
    isForce: false,
    isModal: false,
    clearCache: '',
    version: '',
    regDate: '',
    hasUpdate: false
  },
  loginInfo: {
    userNo: 0,
    loginStatus: '',
    loginDate: '',
    policyVersion: ''
  },
  stores: [],
  position: {
    address: '',
    addressDetail: '',
    latitude: 0, // 위도
    longitude: 0, // 경도,
    isSaveAddress: false
  },
  points: 0,
  coupons: [],
  access: 0,
  isOnAlert: true
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
